module.exports = __webpack_public_path__ + "static/media/shahitukda.e125d53c.jpg";